import script from "./FtrMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FtrMenu.vue?vue&type=script&setup=true&lang=js"

import "./FtrMenu.vue?vue&type=style&index=0&id=3d2ccfb0&lang=css"

const __exports__ = script;

export default __exports__